import styled from 'styled-components';
import InputMask from 'react-input-mask';

//Base principais divs

export const ContainerRolagem = styled.div`
  height: 810px;
//   overflow-y: auto;
  width:100%;

  @media (max-width: 768px) and (max-width: 1023px){
    overflow-y: hidden;
    height: auto;
  }
`;

export const ContainerInformation = styled.div`
    display:inline-flex;
    width:100%;
    height: 100%;
    // overflow: hidden;
    // position: fixed;
    // top: 0;
    // left: 0;

    @media (max-width: 425px) {
    display:block;
    }

    @media (max-width: 768px) {
    display:block;
    }
`;

export const ContainerInformacoes = styled.div`
    display:flex;
    flex-direction:column;
    justify-content: center;
    align-items: center;
    background: #F5F5F5;
    // padding: 51px 91px 51px 90px;
    padding: 0 5%;
    padding-top: 30px;
    padding-bottom: 30px;
    // height: 804px;
    // overflow-y: auto;

    // @media (max-width: 425px) {
    // padding: 51px 30px 51px 30px;
    // }

    // @media (min-width: 1024px) and (max-width: 1439px) {
    // padding: 51px 30px 51px 30px;
    // }
`;

export const BoxForm = styled.div`
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width:100%;
    // width: 538px;

    // @media (max-width: 425px) {
    // width: 100%;
    // }

    // @media (min-width: 1024px) and (max-width: 1439px){
    // width: 100%;
    // }

    // @media (min-width: 1441px) and (max-width: 2560px){
    // width: 45vw;
    // }
`;

export const BoxCarrinho = styled.div`
    display: inline-flex;
    flex-direction: column;
    // justify-content: center;
    align-items: flex-start;
    width:100%;
    // width: 538px;

    // @media (min-width: 1024px)and (max-width: 1439px) {
    // width: 450px;
    // }

    // @media (min-width: 1441px) and (max-width: 2560px){
    // width: 45vw;
    // }
`;

export const ContainerCarrinho = styled.div`
    display:flex;
    flex-direction:column;
    justify-content: flex-start;
    align-items: center;
    // padding: 51px 91px 51px 90px;
    padding-left:30px;
    // height: 100%;
    width: 75%;

    @media (max-width: 425px) {
    // display: none;
     width: 100%;
      padding: 0px;
    }

    @media (min-width: 1024px) and (max-width: 1439px){
    // padding: 51px 30px 51px 30px;
    }
`;


export const ContinuarMobile = styled.div`
    

    

    @media (max-width: 500px) {
        display: flow  !important;
    }

   @media (min-width: 501) {
    display: flow !important;
    }
`;

export const NavCaminho = styled.div`
    display:flex;
    align-items: center;
    gap: 10px;

    @media (max-width: 425px) {
    gap:3px;
    }

    @media (max-width: 320px) and (max-width: 375px) {
    gap:0px;
    }

    @media (min-width: 1024px) and (max-width: 1439px){
    gap:4px;
    }
`;

export const FlexContato = styled.div`
    display:flex;
    align-items: center;
    justify-content: space-between;
`;

export const NavContaLoginFlex = styled.div`
    display:flex;
    align-items: center;
    gap:4px;
`;

export const FlexTable = styled.div`
    display:flex;
    // align-items: center;
    gap:15px;
    margin-bottom:15px;

    @media (max-width: 425px) {
    flex-direction:column;
    }
`;

export const FlexTableMobile = styled.div`
    display:flex;
    align-items: center;
    gap:15px;
    margin-bottom:15px;

    @media (max-width: 425px) {
    flex-direction:row;
    // width: 100%;
    }
`;

export const ContainerInputs = styled.div`
    width: 100%;
`;


//Estilo padrao de textos

export const P1 = styled.p`
    color: #000;

    /* h3 */
    font-family: Montserrat;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px; /* 133.333% */
    letter-spacing: 0.1px;
    margin: 10px 0px;
`;

export const P2 = styled.p`
    color: #000;
    // text-align: center;

    /* link */
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 171.429% */
    letter-spacing: 0.2px;

    @media (max-width: 425px) {
    font-size: 12px;
    }

    @media (max-width: 320px) and (max-width: 375px) {
    font-size: 10px;
    }
`;

export const P3 = styled.p`
    color: #303030;
    font-family: Montserrat;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
`;

export const P4 = styled.p`
    color: #1C1B1B;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
`;

export const P5 = styled.p`
    color: #FFF;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 125% */
    margin:0;
`;

export const P6 = styled.label`
    color: #505050;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    @media (max-width: 320px) and (max-width: 375px) {
    font-size: 8.8px;
    }

    @media (min-width: 375px) and (max-width: 425px) {
    font-size: 10.5px;
    }
`;

export const P7 = styled.p`
    color: #848484;
    text-align: center;
    font-family: Montserrat;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-decoration-line: underline;
    cursor:pointer;
`;

export const P8 = styled.p`
    color: #505050;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;

export const P9 = styled.p`
    color: #848484;
    // text-align: center;

    /* h6 */
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 171.429% */
    letter-spacing: 0.2px;

    ${props => props.active && `
        color: #000;

        /* link */
        font-family: Montserrat;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px; /* 171.429% */
        letter-spacing: 0.2px;

        @media (max-width: 425px) {
        font-size: 12px;
        }

        @media (max-width: 320px) and (max-width: 375px) {
        font-size: 10px;
        }
    `}

    @media (max-width: 425px) {
    font-size: 12px;
    }

    @media (max-width: 320px) and (max-width: 375px) {
    font-size: 10px;
    }
`;

export const P10 = styled.p`
    color: #505050;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    @media (max-width: 425px) {
    font-size: 12px;
    }
`;

export const P11 = styled.p`
    color: #1C1B1B;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    cursor:pointer;

    @media (max-width: 425px) {
    font-size: 12px;
    }
`;

export const P12 = styled.p`
    color: #737373;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin:0;
    // white-space: nowrap;
`;

export const P13 = styled.p`
    color: #1C1B1B;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin:0;
`;

export const P14 = styled.p`
    color: #545454;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
`;

export const P15 = styled.p`
    color: #737373;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`;

export const P16 = styled.p`
    color: #333;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin:0;
`;


//Estilo padrao para os inputs

export const StyledInput = styled(InputMask)`
    display: flex;
    // width: 100%;
    height: 40px;
    padding: 0px 0px 0px 10px;
    align-items: center;
    border-radius: 10px;
    border: 1px solid #D2D2D2;
    background: #FFF;
    outline:none;

  &::placeholder {
    color: #000;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: none;
  }

  @media (min-width: 768px) {
    width: 100%;
  }
`;

export const StyledInputMobile = styled.input`
    display: flex;
    // width: 100%;
    height: 40px;
    padding: 0px 0px 0px 10px;
    align-items: center;
    border-radius: 10px;
    border: 1px solid #D2D2D2;
    background: #FFF;
    outline:none;

  &::placeholder {
    color: #000;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  @media (max-width: 425px) {
    width: 100%;
  }

  @media (min-width: 768px) {
    width: 100%;
  }
`;
export const StyledInput2 = styled.input`
    display: flex;
    width: 20%;
    height: 40px;
    padding: 0px 0px 0px 10px;
    align-items: center;
    border-radius: 10px;
    border: 1px solid #D2D2D2;
    background: #FFF;
    outline:none;

  &::placeholder {
    color: #000;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  @media (max-width: 425px) {
    width: 40%;
  }

  @media (min-width: 1024px) and (max-width: 1439px){
    width: 30%;
  }
`;

export const StyledInputEmail = styled.input`
    display: flex;
    // width: 100%;
    height: 40px;
    padding: 0px 0px 0px 10px;
    align-items: center;
    border-radius: 10px;
    border: 1px solid #D2D2D2;
    background: #FFF;
    outline:none;

  &::placeholder {
    color: #000;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  @media (min-width: 768px) {
    width: 100%;
  }
`;

export const StyledSelect = styled.select`

    display: flex;
    width: 100%;
    height: 40px;
    padding: 0px 0px 0px 10px;
    align-items: center;
    border-radius: 10px;
    border: 1px solid #D2D2D2;
    background: #FFF;
    outline:none;
    
    &:focus {
        outline: none;
    }
`;

export const OptionStyled = styled.option`
  color: #000;
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
`;

export const InputCheckbox = styled.input`
    width: 18px;
    height: 18px;
    border-radius: 4px;
    border: 1px solid #CDCDCD;
    background: #FFF;

    @media (min-width: 320px) and (max-width: 375px){
    width: 14px;
    height: 14px;
    }
`;

export const BoxCheckbox = styled.div`
    display:flex;
    align-items:center;
    gap:5px;

`;


export const ButtonContinuarCompra = styled.div`
    display: flex;
    padding: 15px 25px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 5px;
    background: #000;
    cursor:pointer;

     @media (max-width: 500px) {
        display: none  !important;
    }

   @media (min-width: 501) {
    display: none !important;
    }

    
`;


export const ButtonContinuarCompraMobile = styled.div`
    display: none;
    padding: 15px 25px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 5px;
    background: #000;
    cursor:pointer;

     @media (max-width: 500px) {
        display: flex  !important;
    }

   @media (min-width: 501) {
    display: none !important;
    }

    
`;

export const FlexPolitica = styled.div`
    display: flex;
    gap: 15px;
    width: 100%;
`;

export const FlexBack = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding: 30px 0px 30px 0px;
    border-bottom: solid 1px #D2D2D2;
`;

export const FlexSecure = styled.div`
    display:flex;
    align-items: center;
`;

export const VoltarFlex = styled.div`
    display:flex;
    align-items: center;
    gap:7px;
    cursor:pointer;

    @media (max-width: 500px) {
        display: none  !important;
    }

   @media (min-width: 501) {
    display: none !important;
    }
`;


export const VoltarFlexMobile = styled.div`
    display:flex;
    align-items: center;
    gap:7px;
    cursor:pointer;

//     @media (max-width: 500px) {
//         display: block  !important;
//     }

//    @media (min-width: 501) {
//     display: none !important;
//     }
`;

//Aparecer e desaparecer

export const CartInformacao = styled.div`
    width: 100%;
`;

export const CartFrete = styled.div`
    width: 100%;
    margin-top: 30px;
    margin-bottom: 6px;
`;

//CartFrete estilos

export const BoxInformacoesUsuarioFrete = styled.div`
    display: flex;
    padding: 15px 22px;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 10px;
    border: 1px solid #D2D2D2;
    background: #FFF;
`;

export const BoxInformacoesUsuarioFrete2 = styled.div`
    display: flex;
    // padding: 15px 22px;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 10px;
    border: 1px solid #D2D2D2;
    background: #FFF;
`;


export const BoxBorder = styled.div`
    display: flex;
    padding: 15px 0px;
    align-items: flex-start;
    gap: 17px;
    width: 100%;
`;


export const FlexFrete = styled.div`
    display: flex;
    // padding: 15px 0px;
    align-items: flex-start;
    gap: 30px;

    @media (max-width: 425px) {
    gap: 18px;
    }

    @media (max-width: 424px) {
    flex-direction:column;
    }
`;

export const FlexFreteMobile = styled.div`
    display: flex;
    // padding: 15px 0px;
    gap: 30px;
    align-items: center;

    @media (max-width: 425px) {
    gap: 18px;
    
    }

    @media (max-width: 424px) {
    flex-direction:column;
    align-items: flex-start;
    }
`;

export const FlexFrete2 = styled.div`
    display: inline-flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;

    // border:solid 1px green;
    padding:15px 0px 15px 0px;
`;

export const FlexFrete3 = styled.div`
    display:flex;
    // gap:10px;
    margin-left:15px;
`;

export const FlexFrete4 = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

export const FlexFrete5 = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    margin-right:15px;
    padding-top:2px;
`;

//Input circle

export const LabelCircle = styled.label`
  display: inline-block;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  font-size: 22px;
  user-select: none;
`;

export const InputCircle = styled.input.attrs({ type: 'checkbox' })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

export const SpanCircle = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  border: 1px solid #D9D9D9;
  background: #FFF;
  border-radius: 50%;

  ${InputCircle}:checked + & {
    background-color: #000;
  }

  &::after {
    content: "";
    position: absolute;
    display: none;
  }

  ${InputCircle}:checked + &::after {
    display: block;
  }

//   &::after {
//     left: 9px;
//     top: 0px;
//     width: 4px;
//     height: 9px;
//     border: solid white;
//     border-width: 0 3px 3px 0;
//     transform: rotate(45deg);
//   }

&::after {
    content: "";
    position: absolute;
    display: none;
    top: 50%;
    left: 50%;
    width: 5px;
    height: 5px;
    background-color: white;
    border-radius: 50%;
    transform: translate(-50%, -50%);
  }
`;